import React from 'react';
import { css } from '@emotion/react';
import SKUsAndServices from '@/components/Account/SKUsAndServices';

/**
 * The SKUs tab of a shipper's profile: the shipper's SKUs and services, using the account page's
 * SKUs / Services grids in read-only mode. Those grids are MUI, so this tab renders outside the
 * onward-design scope (`scoped: false` in ShipperProfile) and uses plain CSS.
 * @param {{ partnership: Object }} props
 */
const SkusPage = ({ partnership }) => (
    <div
        css={css`
            padding-top: 1.25rem;
        `}
    >
        <SKUsAndServices clientRef={partnership.shipper_id} readOnly />
    </div>
);

export default SkusPage;
